module.exports = __webpack_public_path__ + "img/no_message2.3d44b2fd.svg";